import { render, staticRenderFns } from "./informationDetails.vue?vue&type=template&id=dbe0d796&scoped=true"
import script from "./informationDetails.vue?vue&type=script&lang=js"
export * from "./informationDetails.vue?vue&type=script&lang=js"
import style0 from "./informationDetails.vue?vue&type=style&index=0&id=dbe0d796&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe0d796",
  null
  
)

export default component.exports